import gql from 'graphql-tag';

export default gql`
  fragment EmployeeSearchResultFragment on MapEmployee {
    id
    name
    email
    profilePictureUrl
  }
`;
